module.exports = __webpack_public_path__ + "img/ss-setting1.7cb7db79.png";